<template>
  <div class="box profile-info n-border-top">
    <form @submit.prevent="createPost">
      <textarea
        v-model.trim="content"
        class="form-control input-lg p-text-area"
        rows="2"
        placeholder="Whats in your mind today?"
      ></textarea>
      <div class="box-footer box-form">
        <button type="submit" class="btn btn-azure pull-right">Post</button>
        <ul class="nav nav-pills">
          <a class="file-upload-wrapper">
            <label for="file-upload" class="custom-file-upload">
              <i class="fa fa-camera"></i>
            </label>
            <input
              ref="files"
              id="file-upload"
              type="file"
              accept="image/*"
              multiple="multiple"
              @change="previewMultiImage"
              style="display: none"
            />
          </a>
        </ul>
      </div>
    </form>
    <div class="box-footer box-form preview-wrapper" v-if="previewList.length">
      <div
        v-for="(preview, index) in previewList"
        :key="index"
        class="image-preview"
      >
        <img id="image-thumbnail" :src="preview" alt="preview" />
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const content = ref("");
    const files = ref(null);
    const previewList = ref([]);
    const imageList = ref([]);
    function previewMultiImage(event) {
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        files.value = input.files;
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            previewList.value.push(e.target.result);
          };
          imageList.value.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      }
    }

    async function createPost() {
      try {
        await store.dispatch("post/createPost", {
          content: content.value,
          photos: files.value.files,
        });
        content.value = "";
        previewList.value = [];
        imageList.value = [];
      } catch (error) {
        console.log(error);
      }
    }

    return {
      files,
      content,
      imageList,
      createPost,
      previewList,
      previewMultiImage,
    };
  },
};
</script>
<style scoped>
::file-selector-button {
  display: none;
}
.file-upload-wrapper {
  position: relative;
  display: inline-block;
}

.custom-file-upload {
  display: inline-block;
  padding: 5px 5px 10px 0px;
  cursor: pointer;
  font-size: 16px;
}

.preview-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
}

.image-preview {
  display: flex;
  align-items: center;
}

#image-thumbnail {
  max-width: 100px;
  max-height: 100px;
  display: block;
  padding: 5px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
}
</style>